










import Vue from 'vue'
import { HistoryItemCardData } from '@/models/scripts'
import { CardVariant } from '@/constants/scripts'
import { getHumanizeVariant } from '@/helpers/scripts'

interface Computed {
  isShowVariant: boolean
  variant: string
}

interface Props {
  data: HistoryItemCardData
  isReplay: boolean
}

export default Vue.extend<{}, {}, Computed, Props>({
  computed: {
    isShowVariant() {
      return this.data.v === CardVariant.B
    },
    variant() {
      return getHumanizeVariant(this.data.v)
    },
  },
  props: {
    data: {
      required: true,
    },
    isReplay: {
      default: false,
    },
  },
})
